import { render, staticRenderFns } from "./Statistics1.vue?vue&type=template&id=df0fcbd4&scoped=true"
import script from "./Statistics1.vue?vue&type=script&lang=js"
export * from "./Statistics1.vue?vue&type=script&lang=js"
import style0 from "./Statistics1.vue?vue&type=style&index=0&id=df0fcbd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0fcbd4",
  null
  
)

export default component.exports